module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"overview":"Overview","trailers":"Trailers","trucks":"Trucks"},"de":{"overview":"Übersicht","trailers":"Anhänger","trucks":"Lastwagen"},"fr":{"overview":"Aperçu","trailers":"Remorques","truck":"Camions"},"it":{"overview":"Sommario","trailers":"Rimorchi","truck":"Camion"}}')
  delete Component.options._Ctor
}
